import { render } from "./Notrobat.vue?vue&type=template&id=44d0b537&scoped=true"
const script = {}

import "./Notrobat.vue?vue&type=style&index=0&id=44d0b537&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d0b537"]])

export default __exports__